import * as React from 'react';

import { CompareHubPage } from '../../components/CompareHubPage';
import { trackCompareHubLinkClick } from './tracking';

export const CompareHubPageContainer = () => {
  return <CompareHubPage onClick={trackCompareHubLinkClick} />;
};
